<script>
import { mapGetters, mapState } from "vuex";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Footer from "@/components/Footer";

export default {
  // Included components
  components: {
    FontAwesomeIcon,
    Footer,
  },

  data() {
    return {
      // Whether or not the sidebar is open
      open: false,
    };
  },

  computed: {
    // Mapped state values
    ...mapGetters(["can", "activeTeam"]),
    ...mapState(["user"]),
  },

  methods: {
    // Return whether the route starts with a given path
    path(path) {
      return this.$route.path.startsWith(path);
    },
  },
};
</script>

<template>
  <div class="Outer">
    <b-container fluid class="Main-nav pt-3" :open="open">
      <b-nav vertical v-if="path('/account')">
        <b-nav-item exact-active-class="active" to="/" class="mb-2">
          Home
        </b-nav-item>
        <b-nav-item active-class="active" to="/account" class="mb-2">
          Account
          <div>
            <b-nav-item
              exact-active-class="active"
              to="/account"
              class="mb-2 mt-2"
            >
              General
            </b-nav-item>
            <b-nav-item
              active-class="active"
              to="/account/invitations"
              class="mb-2"
            >
              Invitations
            </b-nav-item>
            <b-nav-item
              active-class="active"
              to="/account/security"
              class="mb-2"
            >
              Security
            </b-nav-item>
          </div>
        </b-nav-item>
      </b-nav>
      <b-nav vertical v-else-if="path('/help')">
        <b-nav-item exact-active-class="active" to="/" class="mb-2">
          Home
        </b-nav-item>
        <b-nav-item active-class="active" to="/help" class="mb-2">
          Help
          <div>
            <b-nav-item
              exact-active-class="active"
              to="/help"
              class="mb-2 mt-2"
            >
              General
            </b-nav-item>
            <b-nav-item active-class="active" to="/help/faq" class="mb-2">
              FAQ
            </b-nav-item>
          </div>
        </b-nav-item>
      </b-nav>
      <b-nav vertical v-else>
        <b-nav-item exact-active-class="active" to="/" class="mb-2">
          Overview
        </b-nav-item>
        <b-nav-item
          v-if="can.groups.view"
          active-class="active"
          to="/groups"
          class="mb-2"
        >
          Groups
        </b-nav-item>
        <b-nav-item
          v-if="can.workers.view"
          active-class="active"
          to="/workers"
          class="mb-2"
        >
          Workers
        </b-nav-item>
        <b-nav-item
          v-if="can.billing.manage && activeTeam.billing_id"
          active-class="active"
          to="/billing-portal"
          class="mb-2"
        >
          Billing
        </b-nav-item>
        <b-nav-item
          v-if="can.alerts.view"
          active-class="active"
          to="/alerts"
          class="mb-2"
        >
          Monitoring
          <div v-if="path('/alerts')">
            <b-nav-item
              exact-active-class="active"
              to="/alerts"
              class="mb-2 mt-2"
            >
              Alerts
            </b-nav-item>
            <b-nav-item active-class="active" to="/alerts/events" class="mb-2">
              Events
            </b-nav-item>
          </div>
        </b-nav-item>
        <b-nav-item active-class="active" to="/team" class="mb-2">
          Settings
          <div v-if="path('/team')">
            <b-nav-item
              exact-active-class="active"
              to="/team"
              class="mb-2 mt-2"
            >
              General
            </b-nav-item>
            <b-nav-item
              v-if="can.roles.manage"
              active-class="active"
              to="/team/roles"
              class="mb-2 mt-2"
            >
              Roles
            </b-nav-item>
            <b-nav-item
              v-if="can.members.view"
              active-class="active"
              to="/team/members"
              class="mb-2 mt-2"
            >
              Members
            </b-nav-item>
            <b-nav-item
              v-if="can.members.edit"
              active-class="active"
              to="/team/invitations"
              class="mb-2"
            >
              Invitations
            </b-nav-item>
          </div>
        </b-nav-item>
        <!-- <b-nav-item v-if="can.facilities.view"
            active-class="active"
            to="/facilities"
            class="mb-2">
             Facilities
            </b-nav-item> -->
        <b-nav-item
          v-if="user.isStaffAdmin"
          active-class="active"
          to="/reactor-admin/capacity"
          class="mb-2"
        >
          Reactor Admin
          <div v-if="path('/reactor-admin')">
            <b-nav-item
              exact-active-class="active"
              to="/reactor-admin/capacity"
              class="mb-2 mt-2"
            >
              Capacity
            </b-nav-item>
            <b-nav-item
              active-class="active"
              to="/reactor-admin/contracts"
              class="mb-2"
            >
              Contracts
            </b-nav-item>
          </div>
        </b-nav-item>
      </b-nav>
    </b-container>
    <div class="Content" @mousedown="open = false">
      <b-container fluid class="Breadcrumbs">
        <b-breadcrumb>
          <b-link class="Bars">
            <FontAwesomeIcon
              icon="bars"
              size="lg"
              class="mr-3"
              @click="open = true"
            />
          </b-link>
          <slot name="breadcrumbs" />
        </b-breadcrumb>
      </b-container>
      <b-container fluid class="p-3 Inner">
        <slot />
      </b-container>
      <Footer />
    </div>
  </div>
</template>

<style scoped>
.Outer {
  position: relative;
  width: 100%;
  height: 100%;
}

.Main-nav {
  width: 15rem;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  transition: width 0.3s, left 0.3s;
  position: fixed;
  z-index: 10;
  top: 4rem;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  transform: translate3d(0, 0, 0);
}

.Content {
  margin-left: 15rem;
  width: calc(100% - 15rem);
  z-index: 9;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.Breadcrumbs .Bars {
  display: none;
}

.Breadcrumbs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.breadcrumb {
  background-color: transparent;
  border: none;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 1024px) {
  .Breadcrumbs .Bars {
    display: block;
  }

  .Main-nav {
    display: none;
  }

  .Main-nav[open] {
    display: block;
    background: linear-gradient(
      rgb(249, 250, 255) 0%,
      rgba(255, 255, 255) 1000px
    );
  }

  .Main-nav[open] ~ .Content {
    filter: blur(1.5px);
    overflow: hidden;
    height: 100%;
  }

  .Content {
    margin-left: 0rem;
    width: calc(100% - 2px);
    right: 1rem;
    z-index: 9;
  }
}

.Bars {
  color: rgba(0, 0, 0, 0.7);
}

.Inner {
  flex: 1;
}
</style>
